// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 2,
    },
    // Store Custom Code
    widgetGroup: {
        returnRequest: "Return Request" as any,
        returnSlip: "Return Slip" as any,
    },
    pageType: {
        returnRequestRmaPage: "ReturnRequestRmaPage",
        returnSlipPage: "ReturnSlipPage",
        backOrdersPage: "BackOrdersPage",
    },
    rmaReasonCode: {
        incorrectProductReceived: "002",
    },
});
